<template>
  <div v-show="show">
    <FormKit
      :help-position="helpPosition"
      :help="field.instructions"
      :label-position="labelPosition"
      :label="field.name"
      :name="name"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="field.defaultValue"
      type="tel"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldLabelPosition, fieldName, fieldTextValidationArray, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const labelPosition = fieldLabelPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const show = fieldVisible(props.field)
const validation = [...fieldValidationArray(props.field), ...fieldTextValidationArray(props.field, 255)]
</script>
